/**
 * Mapea el propósito del préstamo al formato de GoHighLevel
 * @param {string} purpose - Propósito del préstamo
 * @returns {string} Propósito mapeado
 */
export const mapLoanPurpose = (purpose) => {
  const purposeMap = {
    "Purchase": "Purchase",
    "Cashout Refi": "C/O Refi",
    "NoCashout Refi": "Refi"
  };
  return purposeMap[purpose] || "Purchase";
};

/**
 * Mapea el tipo de préstamo al formato de GoHighLevel
 * @param {string} type - Tipo de préstamo
 * @returns {string} Tipo mapeado
 */
export const mapLoanType = (type) => {
  const typeMap = {
    "Rental": "DSCR",
    "Bridge": "Bridge",
    "Fix & Flip": "Fix and Flip"
  };
  return typeMap[type] || "Bridge";
};

/**
 * Mapea el tipo de unidad al formato de GoHighLevel
 * @param {string} type - Tipo de unidad
 * @returns {string} Tipo mapeado
 */
export const mapUnitType = (type) => {
  const unitTypeMap = {
    "Single family": "Single Family",
    "2-4 unit property": "2-4 Unit",
    "Warrantable condo": "Condo",
    "Non-warrantable condo": "Condo",
    "5-20 unit property": "5-20 Unit",
    "Mixed-use property": "Mixed Use"
  };
  return unitTypeMap[type] || "Other";
}; 